var _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamrea(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 71,
    r: 63,
    fill: "#F6F6F7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 71,
    r: 70,
    stroke: "#F8B427",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.2732 72.426C82.2732 78.9179 76.992 84.1991 70.5 84.1991C64.008 84.1991 58.7289 78.9179 58.7289 72.426C58.7289 65.934 64.008 60.6528 70.5 60.6528C76.992 60.6528 82.2732 65.936 82.2732 72.426ZM107 55.7086V89.1473C107 93.6051 103.386 97.2194 98.9279 97.2194H42.0721C37.6143 97.2194 34 93.6051 34 89.1473V55.7086C34 51.2508 37.6143 47.6365 42.0721 47.6365H52.0008V44.8436C52.0008 40.9428 55.161 37.7805 59.0639 37.7805H81.9361C85.839 37.7805 88.9992 40.9428 88.9992 44.8436V47.6345H98.9279C103.386 47.6365 107 51.2508 107 55.7086ZM88.3272 72.426C88.3272 62.5962 80.3298 54.5987 70.5 54.5987C60.6722 54.5987 52.6748 62.5962 52.6748 72.426C52.6748 82.2557 60.6722 90.2532 70.5 90.2532C80.3298 90.2532 88.3272 82.2557 88.3272 72.426Z",
    fill: "#F8B427"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamrea);
export default __webpack_public_path__ + "static/media/camrea.a3fce3426b36e279aa05059872386b07.svg";
export { ForwardRef as ReactComponent };